import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import { Button } from '../Button/Button';

const DEFAULT_SHOW_MORE_LABEL = 'Show more';
const DEFAULT_HIDE_LABEL = 'Hide';
const EMPTY_TEXT_PLACEHOLDER = '-';

type Props = {
  hideLabel?: React.ReactNode;
  text: string;
  maxLength?: number;
  label: React.ReactNode;
  showMoreLabel?: React.ReactNode;
  textMarginLeft?: number;
};

const getDisplayedText = (text: string, expanded: boolean, maxLength: number) => {
  if (expanded || text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + '...';
};

export const ShowMore = ({ hideLabel, text, maxLength = 100, label, showMoreLabel, textMarginLeft = 0 }: Props) => {
  const [expanded, setExpanded] = useState(false);
  const toggleLabel = expanded ? (hideLabel ?? DEFAULT_HIDE_LABEL) : (showMoreLabel ?? DEFAULT_SHOW_MORE_LABEL);
  const displayedText = getDisplayedText(text || EMPTY_TEXT_PLACEHOLDER, expanded, maxLength);

  return (
    <Box
      sx={{
        whiteSpace: 'pre-wrap',
      }}
    >
      {label}
      <Box
        sx={{
          ml: textMarginLeft,
        }}
      >
        <Typography>{displayedText}</Typography>
        {text && text.length > maxLength ? (
          <Button
            variant="text"
            onClick={() => setExpanded(!expanded)}
            endIcon={expanded ? <ExpandLess /> : <ExpandMore />}
          >
            {toggleLabel}
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};
